@if (region.result$ | async; as result) {
    @if (result.value?.data; as regionData) {

        <app-header [breadcrumbs]="['Region administration', regionData.name]" mainHeading="{{regionData.name}}"
                    [links]="['/regions', '/regions/' + regionData.id]">
            <div providerBadge>
                @if (regionData.status) {
                    <cll-badge colour="primary">Active</cll-badge>
                } @else {
                    <cll-badge colour="error">Inactive</cll-badge>
                }
            </div>
            @if ((user()?.permissions?.permissions ?? []).includes('region.update')) {
                @if (user()?.permissions?.permission_name?.includes('Administrator')) {
                    <div headingButton>
                        <button cll-icon-button
                                [cllMenuTriggerFor]="menu"
                                (click)="$event.stopPropagation()">
                            <cll-icon>more_vert</cll-icon>
                        </button>

                        <ng-template #menu>
                            <cll-menu>
                                @if (regionData.status) {
                                    <button cllMenuItem (click)="changeStatus(regionData, false)">
                                        <cll-icon type="outlined">toggle_off</cll-icon>
                                        Mark as inactive
                                    </button>
                                } @else {
                                    <button cllMenuItem (click)="changeStatus(regionData, true)">
                                        <cll-icon type="outlined">toggle_on</cll-icon>
                                        Mark as active
                                    </button>
                                }
                            </cll-menu>
                        </ng-template>
                    </div>
                }
            }
        </app-header>

        <div class="regions-view-container">
            <div class="view-accordion">
                <cll-collapsible-card>
                    <cll-card-header>
                        <cll-icon cllCardIcon type="outlined">person</cll-icon>
                        <cll-card-title>General information</cll-card-title>
                        <cll-card-subtitle>Region reference, region name
                        </cll-card-subtitle>
                    </cll-card-header>
                    <app-region-general-information (editDetailsEvent)="editRegionDetails()" [regionData]="region" />
                </cll-collapsible-card>
            </div>
            <div>
                <div class="tabs-container">
                    <cll-horizontal-tabs [appearance]="tabAppearance" [tabItems]="tabItems"
                                         [currentTabId]="currentTabId"
                                         (currentTabIdChange)="currentTabIdChange($event)" />

                    @if (this.isPrioritiesTabOpen) {
                        @if (this.region; as regionData) {
                            <app-region-priorities-tab [regionData]="regionData" (addPriorityEvent)="addPriorityEvent()"
                                                       (editPriorityEvent)="editPriorityEvent($event)" />
                        }
                    }

                    @if (this.isZonesTabOpen) {
                        @if (this.region; as regionData) {
                            <app-region-zones-tab [regionData]="regionData" (addZoneEvent)="addZoneEvent()"
                                                  (editZoneEvent)="editZoneEvent($event)" />
                        }
                    }

                    @if (this.isProvidersTabOpen) {
                        @if (this.region; as regionRefreshable) {
                            <app-region-providers-tab
                                [regionData]="regionRefreshable"
                                [regionId]="regionData.id"
                                (providerRemovedEvent)="auditRefresh$.next()" />
                        }
                    }

                    @if (this.isAuditTabOpen) {
                        <app-region-audit-tab [externalRefresh$]="auditRefresh$" />
                    }
                </div>
            </div>
        </div>

    }
}
